import { IScope } from "angular";
import { IIndicator } from "@gtmhub/error-handling";
import { localize } from "@gtmhub/localization";
import { ICollection } from "@webapp/core/core.models";
import { Task } from "@webapp/tasks/models/tasks.models";
import { UiToastService } from "@webapp/ui/toast/services/toast.service";
import { TaskService } from "../services/task.service";
import { TaskEvents } from "../task.events";

export interface IArchivedTasksScope extends IScope {
  tasks: ICollection<Task>;
  indicators: {
    loading?: IIndicator;
    unarchiving?: IIndicator;
  };
  unarchive(task: Task): void;
}

export class ArchivedTasksCtrl {
  private taskEvents: TaskEvents;

  public static $inject = ["$scope", "TaskService", "UiToastService"];

  constructor(private $scope: IArchivedTasksScope, private tasksService: TaskService, private toastService: UiToastService) {
    this.taskEvents = new TaskEvents(this.$scope);

    this.$scope.unarchive = this.unarchive;
    this.$scope.indicators = {
      loading: { progress: true },
    };
    this.init();
  }

  private init = () => {
    return this.tasksService.getList({ archived: true }).then(
      (tasks) => {
        delete this.$scope.indicators.loading;
        this.$scope.tasks = tasks;
      },
      (error) => (this.$scope.indicators.loading = { error })
    );
  };

  private unarchive = (task: Task) => {
    this.updateTask(task, { archived: false });

    this.toastService.success(localize("task_unarchived"), {
      uiShouldTimeout: true,
      uiDuration: 5000,
      uiOffset: 40,
      uiPrimaryCTA: localize("undo"),
      uiOnPrimaryAction: () => {
        this.updateTask(task, { archived: true });
      },
    });
  };

  private updateTask = (task: Task, update: Partial<Task>) => {
    this.$scope.indicators.unarchiving = { progress: true };

    for (let i = 0; i < this.$scope.tasks.items.length; i++) {
      if (this.$scope.tasks.items[i].id === task.id) {
        this.$scope.tasks.items[i].archived = update.archived;
      }
    }

    this.tasksService.update(task.id, update).then(
      (task) => {
        delete this.$scope.indicators.unarchiving;
        this.taskEvents.broadcastTaskUpdated({ task, update });

        this.init();
      },
      (error) => (this.$scope.indicators.unarchiving = { error })
    );
  };
}
